import React from 'react';
import { motion } from 'framer-motion';
export function CostSection() {
  const costs = [{
    sin: 'Precio mal calculado',
    costo: 'Estás pagando por trabajar (pérdida mensual)'
  }, {
    sin: 'Insumos comprados de más',
    costo: 'Plata tirada en la heladera que se pudre'
  }, {
    sin: 'Ventas perdidas por WhatsApp',
    costo: 'Clientes que se van a la competencia'
  }, {
    sin: 'Fin de semana caótico',
    costo: 'Estrés, peleas en casa y cansancio extremo'
  }, {
    sin: 'Domingo sin ganancia clara',
    costo: 'El mismo ciclo de frustración el próximo mes'
  }];
  return <section className="py-20 px-4 pt-[25px] pb-[25px]" data-id="element-109">
      <div className="max-w-4xl mx-auto" data-id="element-110">
        <div className="text-center mb-12" data-id="element-111">
          <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-112">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12" data-id="element-113">
          {costs.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border p-6 rounded-xl" data-id="element-114">
              <div className="text-gray-400 text-sm mb-2" data-id="element-115">
                Sin UltraPack: {item.sin}
              </div>
              <div className="text-red-400 font-bold" data-id="element-116">
                Costo real: {item.costo}
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-117">
          <p className="text-2xl md:text-3xl font-black text-white" data-id="element-118">
            El próximo fin de semana puede ser diferente.{' '}
            <span className="text-brand" data-id="element-119">☕</span>
          </p>
          <p className="text-lg text-gray-400 mt-2" data-id="element-120">La decisión es tuya.</p>
        </div>
      </div>
    </section>;
}